/* This is the Root component mainly initializes Redux and React Router. */

import React from 'react';
import { Provider } from 'react-redux';
import { Router, Route, Switch } from 'react-router-dom';
import history from './common/history';
import { by } from './common/routerAccess';
import Dispatcher from './common/Dispatcher';
import routeConfig from './common/routeConfig';
import configStore from './common/configStore';
import { checkLogin } from './features/authentification/redux/auth';
import { sso } from './features/authentification/redux/sso';
export const store = configStore();

function renderRouteConfigV3(Container, routes, contextPath, routerAccess) {
  // Resolve route config object in React Router v3.
  const children = []; // children component list

  const renderRoute = (item, routeContextPath, parentAccess) => {
    //build a context
    let newContextPath;
    if (/^\//.test(item.path)) {
      newContextPath = item.path;
    } else {
      newContextPath = `${routeContextPath}/${item.path}`;
    }
    newContextPath = newContextPath.replace(/\/+/g, '/');

    //access - definition
    let access = [];
    if(item.access){
      if(typeof item.access === "string")
        access.push(item.access)
      else
        access = item.access.slice();
    } else {
      access = parentAccess.slice();
    }


    if (item.component && item.childRoutes) {
      children.push(renderRouteConfigV3(item.component, item.childRoutes, newContextPath, access));
    } else if (item.component) {
      children.push(
        <Route 
          key={newContextPath} 
          render={(props) => <Dispatcher access={access} component={item.component} {...props} />}
          path={newContextPath} 
          exact />
        );
    } else if (item.childRoutes) {
      item.childRoutes.forEach(r => renderRoute(r, newContextPath, access));
    }
  };

  routes.forEach(item => renderRoute(item, contextPath, routerAccess));

  // Use Switch as the default container by default
  if (!Container) 
    return (
      <Dispatcher key={"dispatcher" + contextPath} component={Switch} access={routerAccess}>
        {children}
      </Dispatcher>
    );

  return (
    <Dispatcher key={contextPath} component={Container} access={routerAccess}>
      <Switch>
        {children}
      </Switch>
    </Dispatcher>
  );
}

class Root extends React.Component {

  componentWillMount() {
    checkLogin()(store.dispatch)
    this.checkSso()
    this.checkPwa()
  }

  checkSso() {
    const pattern = '?ticket=';
    if (window.location.href.indexOf(pattern) !== -1) {
      const ticket = window.location.href.substr(window.location.href.indexOf(pattern) + pattern.length)
      window.history.replaceState({}, document.title, window.location.href.substr(0, window.location.href.indexOf(pattern)))
      store.dispatch(sso(ticket))
    }
  }

  checkPwa() {
    const pattern = '?source=pwa';
    if (window.location.href.indexOf(pattern) !== -1) {
      window.location.href = `${window.location.href.substr(0, window.location.href.lastIndexOf('/') + 1)}event/presence`
    }
  }

  render() {
    const children = renderRouteConfigV3(null, routeConfig, '/', [by.ALL]);
    return (
      <Provider store={store}>
        <Router history={history}>
          {children}
        </Router>
      </Provider>
    );
  }
}

export default Root;



// WEBPACK FOOTER //
// ./src/Root.js